export default {
  'otp.oldPrice': 'ราคาเดิม ',
  'otp.details': 'รายละเอียดของกิจกรรมฟรีจำกัดเวลา',
  'otp.effective': 'เวลาที่มีผล',
  'otp.userTitle': 'ผู้ใช้ที่ได้รับสิทธิพิเศษ',
  'otp.tip':
    'หากคุณได้เติมเงินสำหรับผลิตภัณฑ์ EngageLab อื่น ๆ แต่ไม่ได้เติมเงิน OTP คุณยังสามารถเข้าร่วมกิจกรรมนี้ได้',
  'otp.service.dsc': 'ผู้ใช้ครั้งแรกของบริการเติมเงินผลิตภัณฑ์ OTP',
  'otp.event': 'งาน',
  'otp.tip1a':
    'ในช่วงเวลาโปรโมชั่น, ผู้ใช้ที่เติมเงิน OTP เป็นครั้งแรกจะได้รับการยกเว้นค่าธรรมเนียมการตรวจสอบ OTP เป็นเวลา',
  'otp.tip1b': '30 วันตามธรรมชาติ',
  'otp.tip1c': 'นับจากวันที่เติมเงิน',
  'otp.notes1': '1. บัญชีหนึ่งสามารถเข้าร่วมกิจกรรมนี้ได้เพียงครั้งเดียว',
  'otp.notes2':
    '2. หลังจากเติมเงินเสร็จสิ้น, จะไม่มีการคืนเงินอีก. หากต้องการความช่วยเหลือเพิ่มเติม, กรุณา',
  'otp.notes2a': 'ติดต่อเรา',
  'otp.notes2b': 'สำหรับรายละเอียด',
  'otp.notes3': '3. EngageLab ขอสงวนสิทธิ์ในการตีความแคมเปญนี้ภายใต้ขอบเขตของกฎหมาย',
  'email.sem.title': 'Limited Time Offer! 500 Free Emails/day for New Users',
  'email.sem.btn': 'Start Now',
};
